<!--
  Kompakt gehalten: in der Kopfleiste ist wenig Platz, und auf einem Tablet
  in der Hand zählt jeder Pixel. Der Text verschwindet auf schmalen Geräten,
  das Symbol und der Zähler bleiben.
-->
<button
  mat-button
  type="button"
  class="offline-status"
  [ngClass]="cssKlasse"
  [matTooltip]="tooltip"
  matTooltipClass="offline-status-tooltip"
  (click)="klick()">

  <mat-icon
    [class.dreht]="status.zustand === 'laeuft'">
    {{ icon }}
  </mat-icon>

  <span class="status-text">{{ status.meldung }}</span>

  <!-- Der Zähler bleibt auch dann sichtbar, wenn der Text ausgeblendet ist. -->
  <span
    class="status-zaehler"
    *ngIf="status.ausstehend + status.konflikte + status.fehlgeschlagen > 0">
    {{ status.ausstehend + status.konflikte + status.fehlgeschlagen }}
  </span>
</button>
